module.exports = {
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/locale.en.js
 ** module id = 6
 ** module chunks = 0
 **/